/**
 * A global namespace for `ArrowLeft` key.
 * e.which = 37 equivalent
 */
const keyArrowLeft = 'ArrowLeft';

export default keyArrowLeft;
